var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.createplusMessages)?_c('span',{staticClass:"CreateplusMessage",domProps:{"innerHTML":_vm._s(_vm.getLabel(_vm.fcontId,_vm.flinkId,_vm.msgkey,_vm.defaultValue))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }